<h1>Community</h1>

<p>Here are some other websites and groups apart of the MLP music community!</p>

<div>
<a href="https://www.horsemusicherald.com">
	<img src="/img/hmh.png" width="100" height=100 />
	<div>
		<div class='title'>Horse Music Herald</div>
		<p>The primary music journalism blog since 2016</p>
	</div>
</a>

<a href="https://pony.fm">
	<img src="/img/ponyfm.png" width="100" height=100 />
	<div>
		<div class='title'>Pony.fm</div>
		<p>A music database and hosting website</p>
	</div>
</a>
<a href="https://www.youtube.com/channel/UCbT0PFbfaYvgv7TSlYfekdA">
	<img src="/img/top10.png" width="100" height=100 />
	<div>
		<div class='title'>Top Brony Music</div>
		<p>A youtube channel featuring the top 10 fan-made MLP songs each month</p>
	</div>
</a>

<a href="https://bronymusiciandatabase.crd.co/">
	<img src="/img/bronymusiciandb.png" width="100" height=100 />
	<div>
		<div class='title'>Brony Musician Database</div>
		<p>A link page to various musician's socials</p>
	</div>
</a>

<a href="https://docs.google.com/spreadsheets/d/1UWGJki4anFbMfhztCsOwnFP4OGj9h-d0fBR_UIYxch8/edit#gid=0">
	<img src="/img/spreadsheet.png" width="100" height=100 />
	<div>
		<div class='title'>Luck's Brony Music Tracking</div>
		<p>A spreadsheet maintained by Luck Rock of brony songs, albums, and more</p>
	</div>
</a>

<!-- My Little Remix -->
	

</div>

<h2>Radio Stations</h2>

<div>
	<a href="https://ponyvillefm.com/">
		<img src="/img/pvfm.png" width="100" height=100 />
		<div>
			<div class='title'>PonyvilleFM</div>
			<p>One of the most popular Brony radio stations</p>
		</div>
	</a>

	<a href="https://www.bronyradiogermany.com">
		<img src="/img/brg.png" width="100" height=100 />
		<div>
			<div class='title'>Brony Radio Germany</div>
			<p>A germany-based MLP radio station</p>
		</div>
	</a>
	<a href="https://fancynoise.net">
		<img src="/img/fancynoise.png" width="100" height=100 />
		<div>
			<div class='title'>Fancy Noise Radio</div>
			<p>Station dedicated to Hardcore, Speedcore, and other extreme electronic genres</p>
		</div>
	</a>
</div>

<h2>Compilation Albums</h2>
<div>
	<a href="https://pinkamenaparty.bandcamp.com">
		<img src="/img/pinkamena.png" width="100" height=100 />
		<div>
			<div class='title'>PINKAMENA PARTY</div>
			<p>Compilation album of hardcore and 18+ music</p>
		</div>
	</a>
	
	<a href="https://poniesatdawn.bandcamp.com">
		<img src="/img/p@d.png" width="100" height=100 />
		<div>
			<div class='title'>Ponies at Dawn</div>
			<p>Aims to bring you the best on offer with regular compilation albums full of incredible music</p>
		</div>
	</a>

	<a href="https://astateofsugar.bandcamp.com">
		<img src="/img/asos.png" width="100" height=100 />
		<div>
			<div class='title'>A State of Sugar</div>
			<p>Only high-quality & delicious tracks to chill your soul and fire your heart</p>
		</div>
	</a>

	<a href="https://equinity.bandcamp.com">
		<img src="/img/equinity.png" width="100" height=100 />
		<div>
			<div class='title'>Equinity</div>
			<p>Charity compilation album group</p>
		</div>
	</a>
</div>

<style>
	a{
		display: inline-flex;
		padding: 15px;
		transition: background-color .3s;
		width: 400px;
	}
	a:hover {
		text-decoration: none;
		background-color: #e6f7ff;

	}
	img {
		margin-right: 20px;
	}

	.title {
		font-size: 1.5em;
		border-bottom: solid 1px black;
	}
</style>